export enum ActivityLevel {
  Sedentary = 'sedentary',
  Moderate = 'moderate',
  Vigorous = 'vigorous',
  Extreme = 'extreme',
}

export enum Goal {
  Lose = 'lose',
  Maintain = 'maintain',
  Gain = 'gain',
}

export enum Gender {
  Male = 'male',
  Female = 'female',
  None = 'none',
}

export interface TDEEProps {
  bmr: number
  activity: ActivityLevel
  modifier?: number
}

export interface UserInput {
  age: number
  activity: ActivityLevel
  heightInCM: number
  selectedGender: Gender
  selectedGoal: Goal
  weightInKg: number
}

export interface Macros {
  carbohydrate: number
  protein: number
  fat: number
}

export interface ImperialUnits {
  feet: number
  inches: number
  stone: number
  pounds: number
}
